import { faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export default function NoOptions() {
    return <FontAwesomeIcon icon={faBan} size={'lg'} />;
}
